var AdaptiveImage = require( "../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/Barcode.31af4840.png","uri@2x": __webpack_public_path__ + "static/media/Barcode.76df17f6.png","uri@3x": __webpack_public_path__ + "static/media/Barcode.a86cf690.png",
    width: 30,
    height: 84
});